module.exports = __webpack_public_path__ + "static/media/toc-brand-guidelines-2.9a944ede.jpg";